const disabledValues = new Set(['false', '0', 'no', 'off']);

export function isNewMembershipsEnabled(): boolean {
  const value = import.meta.env.VITE_NEW_MEMBERSHIPS_ENABLED;
  if (!value) {
    return true;
  }
  return !disabledValues.has(value.toLowerCase());
}
